export default {
  name: 'honour-card',
  props: {
    img: {
      type: String,
      required: true
    }
  }
};